import { ReferralLinkTableRow } from '@/components/misc/ReferralLinksTable/types'
import { ReferralLinkCollectionItem } from '@/types/responses/referral-links'

export function isReferralLinkCollectionItem(
  referralLink: ReferralLinkTableRow,
): referralLink is ReferralLinkCollectionItem {
  return 'users' in referralLink
}
